/**
 * @prop --wf-search-suggestions-border-color: The border color of the form. Default is #CFC6C6.
 * @prop --wf-search-suggestions-image-background-color: The background color of the images.
 * @prop --wf-search-suggestions-border: The border of the container.
 * @prop --animation-duration: The duration of any animations and transitions.
 * @prop --wf-search-suggestions-product-item-text-color: The color of the product-item text.
 * @prop --wf-search-suggestions-item-active-background-color: The background color of the active suggestions item.
 */

$animation-duration: var(--animation-duration, .1s);

:host {
    text-wrap: nowrap;
    background-color: inherit;
    display: grid;
    grid-template-columns: 1fr;
}

a {
    line-height: 36px;
    display: block;
    padding: 0 16px;
    transition: color $animation-duration;
    text-decoration: none;
    color: currentcolor;

    &.active,
    &:hover {
        color: var(--mdc-theme-accent, purple)
    }

    &.active {
        cursor: default;
        pointer-events: none;
    }

    &:focus-visible {
        transition: none;
        background: var(--wf-search-suggestions-item-active-background-color, #f8f7f5);
    }
}

.divider {
    border-left: 1px solid var(--wf-search-suggestions-border-color, #CFC6C6);
    z-index: 1;
}

.suggestion-title {
    display: none;
    color: var(--mdc-theme-accent, purple);
    font-weight: 500;
    line-height: 36px;
    padding: 0 16px;
}

.simple-suggestion-items a,
.suggestion-title {
    padding: 0 16px;
}

.product-suggestion-item-wrapper {
    display: grid;
    grid-template-columns: 80px auto;
    gap: 16px;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid var(--wf-search-suggestions-border-color, #CFC6C6);
}

[type="submit"] {
    margin: 16px 16px 8px;
}

.product-suggestion-item-text-wrapper {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 1.5;
    font-weight: 500;
}

.product-suggestion-item-text {
    color: var(--wf-search-suggestions-product-item-text-color, #908787);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.product-suggestion-item-image-wrapper {
    background-color: var(--wf-search-suggestions-image-background-color, #F8F7F5);
    place-content: center center;
    display: inherit;
    padding: 4px;
}

.product-suggestion-image {
    max-height: 72px;
}

[part="suggestions-section"] {
    padding: 8px 0;
}

[part="no-results-message"] {
    padding: 16px;
}

@media screen and (min-width: 1162px) {
    :host {
        max-height: unset;

        &:has(.simple-suggestion-wrapper) {
            grid-template-columns: 1fr 1px 1fr;
        }
    }

    .simple-suggestion-wrapper {
        margin-bottom: 24px;
    }

    .suggestion-title {
        display: block;
    }
}
